import { useState } from "react";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { toast } from "react-toastify";
import classes from "./Share.module.css";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import Modal from "../../../Component/Modal/Modal";
import { IconButton } from "@mui/material";

export default function Share({ historyId, entityName }) {
  const [isCopied, setIsCopied] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const documentPath = `${window.location.origin}/luminaire/conversations/${historyId}`;

  async function handleCopy() {
    await navigator.clipboard.writeText(documentPath);
    setIsCopied(true);
    toast.success("Share link is copied.");
    setTimeout(() => {
      setIsCopied(false);
    }, 4000);
  }

  return (
    <>
      <IconButton
        onClick={() => setShowShareModal(true)}
        sx={{ color: "#1976d2" }}
        title="Share"
      >
        <ShareOutlinedIcon />
      </IconButton>

      <Modal
        handleClose={() => setShowShareModal(false)}
        open={showShareModal}
        title="Share Conversation"
        showActions={false}
      >
        <div>
          <div className={classes.label}>{entityName} Conversations</div>
          <div className={classes.copy_container}>
            <span className={classes.path}>{documentPath}</span>
            <MUIIconButton onClick={handleCopy} tooltip="Click to copy">
              {isCopied ? (
                <DoneOutlinedIcon color="success" />
              ) : (
                <ContentCopyOutlinedIcon />
              )}
            </MUIIconButton>
          </div>
        </div>
      </Modal>
    </>
  );
}
